import {createPinia} from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

// piniaPersist(持久化)
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

//舊版把 JWT 存在 localStorage（AuthState.token 與 v2.authorization）；權杖改放 httpOnly cookie 後，
//在任何 store 還原之前刪掉，不讓它繼續留著被腳本讀走
window.localStorage.removeItem("v2.authorization");
const legacyAuth = JSON.parse(window.localStorage.getItem("AuthState") ?? "null");
if (legacyAuth && "token" in legacyAuth) {
    delete legacyAuth.token;
    window.localStorage.setItem("AuthState", JSON.stringify(legacyAuth));
}

export default pinia;
